<template><div><h1 id="auftraggeberinfo" tabindex="-1"><a class="header-anchor" href="#auftraggeberinfo"><span>Auftraggeberinfo</span></a></h1>
<p>Auftraggeberinfo — Auftraggeberinfo</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Zeigt die offenen Forderungen, Guthaben und die Umsätze der letzten drei Jahre kumuliert an.</p>
<p>Pfad: <code v-pre>Verkauf → Aufträge</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Offene Forderungen</dt>
<dd>Wert aller offenen Posten, korrigiert um Forderungen aus Daueraufträgen (fakturierte Daueraufträge sind ersichtlich) und aus Sammelrechnungen (Einzelfakturen, für die später eine Sammelrechnung erstellt wird, sind nicht ersichtlich)</dd>
<dt>Guthaben</dt>
<dd>Wert aller Guthaben, die frei verfügbar sind. Guthaben entstehen aus Doppelzahlungen, Warenrücknahmen, falsch verbuchten Zahlungseingängen, etc.</dd>
<dt>Umsatz</dt>
<dd>Umsatz kumuliert der letzten drei Jahren, aufgeteilt in Zusagen-, Spenden- und Kaufumsatz.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


